/** @format */
import angular from 'angular';
import _ from 'lodash';

export const approvalStateModelModule = 'sis-components.model.approvalState';

(function () {
    initApprovalStateModel.$inject = ['approvalStateModel'];
    approvalStateModelFactory.$inject = ['DS', '$http', '$log'];
    angular
        .module(approvalStateModelModule, ['js-data'])
        .factory('approvalStateModel', approvalStateModelFactory)
        .constant('APPROVAL_STATE', {
            NOT_READY: 'urn:code:approval-state-type:not-ready',
            READY_FOR_APPROVAL: 'urn:code:approval-state-type:ready-for-approval',
            NOT_APPROVED: 'urn:code:approval-state-type:not-approved',
            APPROVED: 'urn:code:approval-state-type:approved',
        })
        .run(initApprovalStateModel);

    function approvalStateModelFactory(DS, $http, $log) {
        const model = DS.defineResource({
            idAttribute: 'urn',
            name: 'approvalState',
            endpoint: '/kori/api/cached/codebooks/urn:code:approval-state-type',
            watchChanges: false,
        });
        model.lazyGetAll = _.once(() =>
            $http
                .get(model.endpoint)
                .then(response => {
                    model.inject(_.values(response.data));
                    return model.getAll();
                })
                .catch(error => $log.error(error)),
        );
        return model;
    }

    function initApprovalStateModel(approvalStateModel) {
        approvalStateModel.lazyGetAll();
    }
})();
